import { render, staticRenderFns } from "./AudienceAndTopup.vue?vue&type=template&id=65122d84&scoped=true&"
import script from "./AudienceAndTopup.vue?vue&type=script&lang=js&"
export * from "./AudienceAndTopup.vue?vue&type=script&lang=js&"
import style0 from "./AudienceAndTopup.vue?vue&type=style&index=0&id=65122d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65122d84",
  null
  
)

export default component.exports